<template>
  <div class="my-3 py-2 container-fluid">
    <div v-if="userRole === 'Super-Admin' || userRole === 'Admin'">
      <button
        v-if="lastSeason"
        @click="sendReminders"
        class="mb-3 btn btn-sm btn-danger"
      >
        {{ $t("payments.sendReminders") }}
      </button>
    </div>
    <div class="card mb-4">
      <div class="card-header pb-0"></div>
      <div class="card-body px-0 pt-0 pb-2">
        <div class="table-responsive p-0">
          <table class="table align-items-center mb-0">
            <thead>
              <tr>
                <th
                  class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 col-2"
                >
                  {{ $t("parents.parent") }}
                </th>
                <th
                  class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 col-1"
                >
                  {{ $t("parents.sendigReminders") }}
                </th>
                <th
                  class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 col-2"
                >
                  {{ $t("kids.kid") }}
                </th>
                <th
                  class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2 col-1"
                >
                  {{ $t("teachers.mobile") }}
                </th>
                <th
                  class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2 col-1"
                >
                  {{ $t("kids.birthday") }}
                </th>
                <th
                  class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 col-1"
                >
                  {{ $t("kids.subscribedSubcourse") }}
                </th>
                <th
                  class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 col-1"
                >
                  {{ $t("parents.unpaidInstallments") }}
                </th>
                <th
                  class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 col-1"
                >
                  {{ $t("teachers.details") }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in paginatedData" :key="item.id">
                <td>
                  <div class="d-flex px-2 py-1">
                    <soft-avatar
                      :img="item.parent_object.image"
                      size="sm"
                      border-radius="lg"
                      class="me-2 mt-0"
                      alt="user1"
                    />
                    <div class="d-flex flex-column justify-content-center">
                      <span class="text-center text-xs font-weight-bold mb-0">
                        {{ item.parent_object.parent_name }}
                      </span>
                    </div>
                  </div>
                </td>
                <td>
                  <p
                    v-if="
                      (lastSeason && userRole === 'Super-Admin') ||
                      userRole === 'Admin'
                    "
                    class="text-center mb-0 ps-5"
                  >
                    <soft-switch
                      :key="item.parent_object.reminder"
                      id="flexSwitchCheckDefault"
                      name="reminder"
                      class="ms-auto"
                      :checked="item.parent_object.reminder == 1 ? true : false"
                      @change="changeReminder(item.parent_object.id)"
                    >
                    </soft-switch>
                  </p>
                </td>
                <td class="ps-6">
                  <div class="d-flex">
                    <soft-avatar
                      :img="item.image"
                      size="sm"
                      border-radius="lg"
                      class="me-2 mt-0"
                      alt="user1"
                    />
                    <div
                      class="d-flex flex-column text-center justify-content-center"
                    >
                      <span class="text-center text-xs font-weight-bold mb-0">
                        {{ item.kid_name }}
                      </span>
                    </div>
                  </div>
                </td>
                <td>
                  <p class="text-center text-xs font-weight-bold mb-0">
                    {{ item.mobile }}
                  </p>
                </td>
                <td class="align-middle text-center">
                  <span class="text-secondary text-xs font-weight-bold">
                    {{ item.birthday }}
                  </span>
                </td>
                <td class="align-middle text-center text-sm">
                  <p
                    v-for="sub in item.subcourse"
                    :key="sub.id"
                    class="text-secondary text-xs font-weight-bold"
                  >
                    {{ sub.title }}
                  </p>
                </td>
                <td class="align-middle text-center">
                  <p
                    v-for="sub in item.subcourse"
                    :key="sub.id"
                    class="text-secondary text-xs font-weight-bold"
                  >
                    {{ sub.debt }}
                  </p>
                </td>
                <td class="align-middle text-center">
                  <soft-badge
                    v-if="!item.deleted_at"
                    color="success"
                    variant="gradient"
                    size="sm"
                    @click="goToKids(item.id)"
                    class="cursor-pointer"
                  >
                    {{ $t("teachers.details") }}
                  </soft-badge>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <soft-pagination color="success" size="sm">
      <soft-pagination-item
        prev
        @click="prevPage"
        :disabled="currentPage === 1"
      />
      <div v-for="item in pageCount" :key="item.id">
        <soft-pagination-item v-if="item == currentPage" :label="item" active />
        <soft-pagination-item
          v-if="item != currentPage"
          :label="item"
          @click="currPage(item)"
        />
      </div>
      <soft-pagination-item
        next
        @click="nextPage"
        :disabled="currentPage === pageCount"
      />
    </soft-pagination>
  </div>
</template>

<script>
import SoftPagination from "@/components/SoftPagination.vue";
import SoftPaginationItem from "@/components/SoftPaginationItem.vue";
import SoftSwitch from "@/components/SoftSwitch.vue";
import SoftAvatar from "@/components/SoftAvatar.vue";
import SoftBadge from "@/components/SoftBadge.vue";
import swal from "sweetalert2";
import axios from "axios";

export default {
  name: "debits",
  data() {
    return {
      kids: [],
      kid: {},
      isChildVisible: false,
      isEditKidVisible: false,
      currentPage: 1,
      pageSize: 8,
      lastSeason: false,
    };
  },
  components: {
    SoftAvatar,
    SoftBadge,
    SoftPagination,
    SoftPaginationItem,
    SoftSwitch,
  },
  computed: {
    paginatedData() {
      // Izračunavanje podataka koji treba da se prikažu na trenutnoj stranici
      const start = (this.currentPage - 1) * this.pageSize;
      const end = start + this.pageSize;
      return this.kids.slice(start, end);
    },
    pageCount() {
      // Ukupan broj stranica
      return Math.ceil(this.kids.length / this.pageSize);
    },
    userRole() {
      return localStorage.getItem("userRole");
    },
  },
  methods: {
    async fetchKids() {
      const response = await axios.get("kids/debt");
      this.kids = response.data.kids;
      this.lastSeason = response.data.last_season;
    },
    async changeReminder(parentId) {
      this.kids = [...this.kids];
      try {
        await axios.get("change-reminder-setting", {
          params: {
            parentId: parentId,
          },
        });
        await this.fetchKids();
      } catch (error) {
        console.error("Došlo je do greške:", error);
      }
    },
    async sendReminders() {
      await swal.fire({
        title: this.$t("global.typePass"),
        input: "password",
        icon: "question",
        showCancelButton: true,
        cancelButtonText: this.$t("global.cancel"),
        cancelButtonColor: "#f54539",
        confirmButtonText: this.$t("global.submit"),
        confirmButtonColor: "#82d616",
        inputAttributes: {
          autocomplete: "off",
        },
        preConfirm: async (login) => {
          try {
            const checkPass = await axios.post("check-pass", {
              password: `${login}`,
            });
            if (checkPass.status == 200) {
              try {
                const response = await axios.post("send-reminders", {
                  kids: this.kids,
                });
                swal.fire({
                  icon: "success",
                  title: this.$t(response.data.message),
                  showConfirmButton: true,
                });
              } catch (error) {
                swal.fire({
                  title: this.$t("global.error") + "!",
                  text:
                    this.$t(error.response.data.message) ||
                    "You are not authorized to perform this action.",
                  icon: "error",
                });
              }
            } else {
              swal.fire({
                title: this.$t("global.actionCancelled"),
                text: "",
                icon: "success",
              });
            }
          } catch (error) {
            if (error.response && error.response.status === 403) {
              swal.fire({
                title: this.$t("global.error") + "!",
                text:
                  this.$t(error.response.data.message) ||
                  "You are not authorized to perform this action.",
                icon: "error",
              });
            } else {
              swal.fire({
                title: this.$t("global.error") + "!",
                text: "Something went wrong. Please try again later.",
                icon: "error",
              });
            }
          }
        },
      });
    },
    goToKids(kidId) {
      this.$router.push({
        name: "Kid",
        params: { kid: kidId, lastSeason: this.lastSeason },
      });
    },
    nextPage() {
      if (this.currentPage < this.pageCount) {
        this.currentPage++;
      }
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },
    currPage(item) {
      this.currentPage = item;
    },
  },
  mounted() {
    this.fetchKids();
  },
};
</script>
